import React, { useEffect, useState } from "react";
import s from "./PremiosMayores.module.css";

//assets
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { dateFormats } from "../../../../helpers/convertDate";
import Pager from "../../../Shared/Pagination/Pagination";
import Swal from "sweetalert2";

//Material
import {
  Button,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Snackbar,
  Alert,
} from "@mui/material";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import UploadRoundedIcon from "@mui/icons-material/UploadRounded";
import masiveDistributionServices from "../../../../api/delivery/masiveDistribution";
import UploadModal from "./UploadModal";
import ConfirmTarasca from "./Confirm";
import useTranslationException from "../../../../helpers/exceptions";
const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: ".9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

const PremiosMayores = () => {
  const dates = dateFormats();
  const { textColor } = useSelector((state) => state.local);
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [edit, setEdit] = useState({
    data: null,
    status: false,
  });

  const [items, setItems] = useState([]);
  const [loadingDelete, setLoadingDelete] = useState({
    id: 0,
    status: false,
  });

  //Paginado
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [sort, setSort] = useState({
    criteria: "DESC",
    field: "",
  });

  const getFiles = () => {
    setLoading(true);
    masiveDistributionServices
      .getFilesTarasca(page, pageSize, sort)
      .then((res) => {
        setItems(res.content);
        setTotalPages(res.totalPages);
      })
      .then(() => setLoading(false))
      .catch((e) => {
        setLoading(false);
        setOpenError(true);
      });
  };

  const handleDelete = (item) => {
    setLoadingDelete({
      id: item.id,
      status: true,
    });
    Swal.fire({
      title: `${t("deleteTarascaTitle")}: ${item.fileName}`,
      text: `${t("deleteTarascaText")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00A36C",
      cancelButtonColor: "#d33",
      confirmButtonText: t("confirm"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        masiveDistributionServices
          .deleteTarascaFile(item.id)
          .then(() => {
            Swal.fire(
              t("successDeleteTarascaTitle"),
              t("successDeleteTarascaText"),
              "success",
            ).then(() => {
              getFiles();
              setLoadingDelete({
                id: 0,
                status: false,
              });
            });
          })
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("anErrorOccurred,TryAgain"),
              t("sorryErrorOcurred"),
            );
            setLoadingDelete({
              id: 0,
              status: false,
            });
          });
      } else {
        setLoadingDelete({
          id: 0,
          status: false,
        });
      }
    });
  };

  useEffect(() => {
    getFiles();
  }, [page, pageSize, sort]);

  const handleEdit = (item) => {
    setEdit({
      data: item,
      status: true,
    });
  };

  const handleSort = (item) => {
    setSort((prev) => ({
      criteria:
        prev.field === item
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: item,
    }));
  };

  return edit.status ? (
    <ConfirmTarasca file={edit} setEdit={setEdit} getFiles={getFiles} />
  ) : (
    <>
      <Grid container className={s.container}>
        <Grid item container xs={11} className={s.header}>
          <Grid
            item
            xs={12}
            lg={5}
            md={8}
            className={s.titleContainer}
            sx={{ justifyContent: "flex-start" }}
          >
            <EmojiEventsIcon sx={{ fontSize: "2rem", color: "primary.main" }} />
            <h4>{t("BigPrices")}</h4>
          </Grid>
          <Grid item xs={12} lg={2} md={3}>
            <Tooltip placement="top" title={t("uploadFile")}>
              <Button
                variant="contained"
                className={s.uploadBtn}
                onClick={() => setOpen(true)}
              >
                <UploadRoundedIcon sx={{ fontSize: "2rem" }} />
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
        {loading ? (
          <Grid item xs={11} className={s.loader}>
            <CircularProgress size={"3rem"} />
          </Grid>
        ) : items?.length ? (
          <Grid item container xs={11} className={s.data}>
            <TableContainer className={s.tableContainer}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("status")}
                    >
                      {`${t("state")} ${sort.field === "status" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("fileName")}
                    >
                      {`${t("archive")} ${sort.field === "fileName" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("gameName")}
                    >
                      {`${t("serie")} ${sort.field === "gameName" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("processDate")}
                    >
                      {`${t("processDate")} ${sort.field === "processDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    {/*<TableCell sx={{color: textColor, fontSize: "18px", fontWeight: 500, fontFamily: 'Roboto, sans-Serif'}}>{t('ConfirmDate')}</TableCell>*/}
                    <TableCell
                      align="center"
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("edit")}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("delete")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items?.map((item, i) => {
                    return (
                      <React.Fragment key={item.id}>
                        <TableRow
                          sx={{
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                        >
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                            onClick={() => handleEdit(item)}
                          >
                            {item.status || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                            onClick={() => handleEdit(item)}
                          >
                            {item.fileName || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                            onClick={() => handleEdit(item)}
                          >
                            {`[${item.serie}] ${item.gameName}` || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                            onClick={() => handleEdit(item)}
                          >
                            {dates.formatDate(item.processDate)}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item.status === "Confirmado" ? (
                              <EditRoundedIcon
                                sx={{
                                  color: "grey",
                                  fontSize: "2rem",
                                  cursor: "not-allowed",
                                }}
                              />
                            ) : (
                              <EditRoundedIcon
                                className={s.iconbtn}
                                sx={{ color: "primary.dark" }}
                                onClick={() => handleEdit(item)}
                              />
                            )}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item.status !== "Activo" ? (
                              <DeleteForeverRoundedIcon
                                sx={{
                                  color: "grey",
                                  fontSize: "2rem",
                                  cursor: "not-allowed",
                                }}
                              />
                            ) : loadingDelete.status &&
                              loadingDelete.id === item.id ? (
                              <CircularProgress size={"2rem"} />
                            ) : (
                              <DeleteForeverRoundedIcon
                                className={s.iconbtn}
                                sx={{ color: "primary.dark" }}
                                onClick={() => handleDelete(item)}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        ) : (
          <Grid item xs={12} className={s.noResults}>
            {t("noResults")}
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: "50px",
          }}
        >
          <Pager
            pageSize={pageSize}
            setPageSize={setPageSize}
            page={page}
            setPage={setPage}
            totalPages={totalPages}
            pageCustom={pageCustom}
            setPageCustom={setPageCustom}
          />
        </Grid>
      </Grid>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
      {open ? (
        <UploadModal open={open} setOpen={setOpen} getFiles={getFiles} />
      ) : null}
    </>
  );
};

export default PremiosMayores;
